import { Translation } from "..";

const de: Translation = {
  common: {
    save: "Speichern",
    cancel: "Abbrechen",
    edit: "Bearbeiten",
    delete: "Löschen",
    remove: "Entfernen",
    submit: "Einreichen",
    back: "Zurück",
    loading: "Laden...",
    search: "Suchen",
    yes: "Ja",
    no: "Nein",
    close: "Schließen",
    confirm: "Bestätigen",
    actions: "Aktionen",
    noData: "Keine Daten verfügbar",
    error: "Ein Fehler ist aufgetreten",
    success: "Erfolg",
    required: "Dieses Feld ist erforderlich",
    invalidUrl: "Geben Sie eine gueltige URL ein",
    nonNegativeNumber: "Geben Sie eine ganze Zahl groesser oder gleich 0 ein",
    optional: "Optional",
    notSet: "Nicht gesetzt",
    descriptionHint:
      "Bitte seien Sie so detailliert und umfassend wie möglich. Geben Sie Kontext, Ziele, erwartetes Verhalten und alle relevanten Einschränkungen an.",
  },
  nav: {
    dashboard: "Dashboard",
    newRequest: "Neue Anfrage",
    requests: "Anfragen",
    inventory: "Inventar",
    newInventory: "Neues Inventarelement",
    users: "Benutzer",
    profile: "Profil",
    admin: "Admin",
    language: "Sprache",
    help: "Hilfe",
    manual: "Benutzerhandbuch",
    logout: "Abmelden",
  },
  requests: {
    title: "Titel",
    description: "Beschreibung",
    audience: "Zielgruppe",
    audienceInternal: "Intern",
    audienceInternalInfo:
      "Wählen Sie diese Option, wenn die Anwendung ausschließlich für Rotoblaas-Mitarbeiter bestimmt ist. Sie ist von außerhalb des Unternehmens nicht zugänglich.",
    audienceExternal: "Extern",
    audienceExternalInfo:
      "Wählen Sie diese Option, wenn die Anwendung auch für Personen außerhalb von Rotoblaas zugänglich sein soll — zum Beispiel über die Website, EService oder andere öffentliche Tools.",
    departments: "Abteilungen",
    needsErpIntegration: "Benötigt ERP-Integration",
    needsErpIntegrationInfo:
      "Wählen Sie diese Option, wenn die Anwendung Daten mit anderen Systemen der Gruppe austauschen oder in diese integriert werden muss. Beispiele: Semiramis, Pimcore, EService, CRM.",
    participants: "Teilnehmer",
    participantsInfo: "Füge Teilnehmer hinzu, die beim Erstellen dieser Anfrage benachrichtigt werden sollen.",
    status: "Status",
    statusDraft: "Entwurf",
    statusNew: "Offen",
    statusInProgress: "In Bearbeitung",
    statusCompleted: "Abgeschlossen",
    responsibleDepartment: "Zuständige Abteilung",
    responsibleDepartmentIntegrations: "Integrationen",
    responsibleDepartmentSoftwareDevelopment: "Softwareentwicklung",
    responsibleDepartmentIct: "ICT",
    estimateDays: "Schätzung (Tage)",
    internalNotes: "Interne Notizen",
    approvedBy: "Genehmigt von",
    approvedAt: "Genehmigt am",
    createdBy: "Erstellt von",
    createdAt: "Erstellt am",
    supervisor: "Vorgesetzter",
    approve: "Genehmigen",
    newRequest: "Neue Anfrage",
    viewRequestPageTitle: "Anfrage #{{id}}: {{title}}",
    editRequestPageTitle: "Bearbeiten: {{title}}",
    allRequests: "Alle Anfragen",
    backToRequests: "Zurück zu den Anfragen",
    backToRequest: "Zurück zur Anfrage",
    filterAll: "Alle",
    filterDraft: "Entwurf",
    filterNew: "Neu",
    filterInProgress: "In Bearbeitung",
    filterCompleted: "Abgeschlossen",
    approveSuccess: "Anfrage erfolgreich genehmigt",
    submitSuccess: "Anfrage erfolgreich eingereicht",
    updateSuccess: "Anfrage erfolgreich aktualisiert",
    managementSection: "Verwaltungsaktionen",
    auditTrail: "Audit-Protokoll",
    deleteRequest: "Anfrage löschen",
    confirmDeleteRequest:
      "Sind Sie sicher, dass Sie diese Anfrage löschen möchten? Diese Aktion kann nicht rückgängig gemacht werden.",
    deleteSuccess: "Anfrage erfolgreich gelöscht",
    noRequests: "Keine Anfragen gefunden",
    typeLabel: "Funktionsanfrage",
  },
  inventory: {
    name: "Name",
    description: "Beschreibung",
    improvementNotes: "Verbesserungshinweise",
    improvementNotesInfo:
      "Füge Verbesserungspunkte, ERP-Integrationen oder alles hinzu, was du nicht eigenständig lösen konntest.",
    githubUrl: "GitHub-URL",
    deploymentLocation: "Deployment-Ort",
    deploymentLocationInfo: "Wo ist das Projekt gespeichert oder installiert? Z. B. SharePoint, lokaler Server…",
    audience: "Zielgruppe",
    audienceInternal: "Intern",
    audienceExternal: "Extern",
    participants: "Teilnehmer",
    status: "Status",
    statusUnderReview: "In Prüfung",
    statusTakenOver: "Übernommen",
    statusRejected: "Abgelehnt",
    statusCompleted: "Abgeschlossen",
    rejectCause: "Ablehnungsgrund",
    rejectCauseNotInteresting: "Nicht interessant",
    rejectCauseDuplicate: "Duplikat",
    rejectCauseNonCompliant: "Nicht konform",
    rejectCauseOutOfScope: "Außerhalb des Umfangs",
    rejectCauseInsufficientInfo: "Unzureichende Informationen",
    rejectCauseNotSustainable: "Nicht nachhaltig",
    rejectCauseOther: "Sonstige",
    rejectNote: "Ablehnungsnotiz",
    attachments: "Anhänge",
    uploadAttachment: "Anhang hochladen",
    addAttachment: "Anhang hinzufügen",
    noAttachments: "Keine Anhänge",
    attachmentUploadFailed:
      "Ein oder mehrere Anhänge konnten nicht hochgeladen werden. Der Eintrag wurde nicht gespeichert – bitte versuchen Sie es erneut.",
    createdBy: "Erstellt von",
    createdAt: "Erstellt am",
    newItem: "Neues Inventarelement",
    allItems: "Alle Elemente",
    viewInventoryPageTitle: "Element #{{id}}: {{title}}",
    editInventoryPageTitle: "Element bearbeiten #{{id}}: {{title}}",
    backToInventory: "Zurück zum Inventar",
    backToInventories: "Zurück zu den Inventaren",
    audienceExternalAlert:
      "Elemente mit externer Zielgruppe müssen HTML- und JS-Einschränkungen entsprechen. Stellen Sie sicher, dass der Code den Webstandards entspricht.",
    submitSuccess: "Inventarelement erfolgreich eingereicht",
    updateSuccess: "Inventarelement erfolgreich aktualisiert",
    managementSection: "Verwaltung",
    noItems: "Keine Inventarelemente gefunden",
    filterAll: "Alle",
    filterUnderReview: "In Prüfung",
    filterTakenOver: "Übernommen",
    filterRejected: "Abgelehnt",
    filterCompleted: "Abgeschlossen",
    fileSize: "Größe",
    uploadedBy: "Hochgeladen von",
    uploadedAt: "Hochgeladen am",
    deleteAttachment: "Anhang löschen",
    confirmDeleteAttachment: "Sind Sie sicher, dass Sie diesen Anhang löschen möchten?",
  },
  notifications: {
    title: "Benachrichtigungen",
    markAllRead: "Alle als gelesen markieren",
    markAsRead: "Als gelesen markieren",
    noNotifications: "Keine Benachrichtigungen",
    unread: "ungelesen",
    seeAll: "Alle Benachrichtigungen anzeigen",
    filterAll: "Alle",
    filterUnread: "Ungelesen",
    actions: {
      new_inventory_item: "hat ein neues Inventarelement hinzugefügt",
      request_approved: "hat eine Entwicklungsanfrage genehmigt",
    },
  },
  profile: {
    language: "Sprache",
    manager: "Manager",
    noManager: "Kein Manager zugewiesen",
    english: "English (UK)",
    usEnglish: "English (US)",
    italian: "Italiano",
    french: "Français",
    german: "Deutsch",
    spanish: "Español",
    saveLanguage: "Sprache speichern",
    languageSaved: "Sprache gespeichert",
    title: "Benutzerprofil & Einstellungen",
    personalInfo: "Persönliche Informationen",
    languageSettings: "Spracheinstellungen",
  },
  dashboard: {
    welcome: "Willkommen",
    allRequests: "Alle Anfragen",
    allInventory: "Alle Elemente",
    myRequests: "Meine Anfragen",
    myInventory: "Meine Elemente",
    recentNotifications: "Neueste Benachrichtigungen",
    createRequest: "Anfrage erstellen",
    createInventory: "Element hinzufügen",
    statusNew: "Neu",
    statusInProgress: "In Bearbeitung",
    statusCompleted: "Abgeschlossen",
    statusToApprove: "Zu Genehmigen",
    total: "Gesamt",
  },
  users: {
    allUsers: "Alle Benutzer",
    addUser: "Benutzer hinzufügen",
    name: "Name",
    firstName: "Vorname",
    lastName: "Nachname",
    email: "E-Mail",
    department: "Abteilung",
    isAdmin: "Admin",
    lastAccess: "Letzter Zugriff",
    noUsers: "Keine Benutzer gefunden",
    addUserSuccess: "Benutzer erfolgreich hinzugefügt",
    userNotFound: "Benutzer nicht gefunden",
    confirmDelete: "Sind Sie sicher, dass Sie diesen Benutzer löschen möchten?",
    roleAll: "Alle",
    roleAdmin: "Admin",
    roleNonAdmin: "Kein Admin",
    withAccess: "Mit Zugriff",
    withoutAccess: "Ohne Zugriff",
  },
  admin: {
    title: "Admin",
    users: "Benutzer",
    noAdminEndpoint: "Hinweis: Die Benutzerverwaltung ist noch nicht über die API verfügbar.",
    email: "E-Mail",
    name: "Name",
    isAdmin: "Admin",
    managerId: "Manager-ID",
    createdAt: "Erstellt am",
  },
};

export default de;
